<template>
	<div>
<!-- 		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="120px">
					<el-form-item label="统计时间" required>
						<datePicker v-model="form.time" :type="type" />
					</el-form-item>
					<el-divider content-position="center">仓库费用</el-divider>
					<el-form-item label="温州仓(WMS)" required>
						<inputNumber v-model="warehouse['01086F84264C3CA5BC64EE7A095A1372']" :type="type" />
					</el-form-item>
					<el-form-item label="佛山仓(WMS)" required>
						<inputNumber v-model="warehouse['F3A01CA63B7D38E9ADBFF7874630E600']" :type="type" />
					</el-form-item>
					<el-form-item label="永年仓(WMS)" required>
						<inputNumber v-model="warehouse['79ADAC90C4B13D9AA6ECDB2EE9FFB1FB']" :type="type" />
					</el-form-item>
					<el-form-item label="气动元件仓" required>
						<inputNumber v-model="warehouse['3919636A4DD732E3ABF977255DBE934C']" :type="type" />
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal> -->
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	// import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	// import inputNumber from '@_system/components/formcomponents/common/inputNumber/index.vue'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			type: {
				default: () => {
					return 'month'
				}
			},
			unit: {
				default: () => {
					return 'month'
				}
			},
		},
		data() {
			return {
				modal_title: '',
				modal_width: 500,
				modal_height: 500,
				form: {
					time: null,
				},
				warehouse: {
					'01086F84264C3CA5BC64EE7A095A1372': 0,
					'F3A01CA63B7D38E9ADBFF7874630E600': 0,
					'79ADAC90C4B13D9AA6ECDB2EE9FFB1FB': 0,
					'3919636A4DD732E3ABF977255DBE934C': 0,
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				
				// this.form = {
				// 	time: null,
				// }
				// this.warehouse = {
				// 	'01086F84264C3CA5BC64EE7A095A1372': 0,
				// 	'F3A01CA63B7D38E9ADBFF7874630E600': 0,
				// 	'79ADAC90C4B13D9AA6ECDB2EE9FFB1FB': 0,
				// 	'3919636A4DD732E3ABF977255DBE934C': 0,
				// }
				// this.modal_title = this.data.name
			},
			modal_show(){
				
				this.$api.downloadstatic.getexcletask({
					code: this.data.code,
				}).then(() => {
					this.$message.success('创建下载任务成功，文件将推送至钉钉')
					this.modal_cancel()
				})
			},
			// submit() {				
			// 	if (!this.form.time) {
			// 		this.$message.error('请选择统计时间')
			// 		return
			// 	}
			// 	for (let i in this.warehouse) {
			// 		if (!this.warehouse[i]) {
			// 			this.$message.error('仓库费用不能为0')
			// 			return
			// 		}
			// 	}
			// 	this.$api.downloadstatic.getexcletask({
			// 		code: this.data.code,
			// 		unit: this.unit,
			// 		type: this.type,
			// 		date: Array.isArray(this.form.time) ? this.form.time : [this.form.time],
			// 		extand: {
			// 			warehouse: this.warehouse,
			// 		}
			// 	}).then(() => {
			// 		this.$message.success('创建下载任务成功，文件将推送至钉钉')
			// 		this.modal_cancel()
			// 	})
			// },
			reset() {

			}
		},
		components: {
			// datePicker,
			// inputNumber
		}
	}
</script>